import {
    FETCH_DOMAIN_NOTES_REQUEST,
    FETCH_DOMAIN_NOTES_SUCCESS,
    FETCH_DOMAIN_NOTES_FAILURE,
    POST_DOMAIN_NOTE_REQUEST,
    POST_DOMAIN_NOTE_SUCCESS,
    POST_DOMAIN_NOTE_FAILURE,
} from './types/domain-notes-action-types';

import MimirService from '../services/mimir-service';

function fetchDomainNotesRequest( domain ){
    return {
        domain,
        type: FETCH_DOMAIN_NOTES_REQUEST,
    };
}
function fetchDomainNotesSuccess( { byId, allIds } ){
    return {
        allIds,
        byId,
        type: FETCH_DOMAIN_NOTES_SUCCESS,
    };
}
function fetchDomainNotesFailure( error ){
    return {
        error,
        type: FETCH_DOMAIN_NOTES_FAILURE,
    };
}

function postDomainNoteSuccess( response ){
    return {
        response,
        type: POST_DOMAIN_NOTE_SUCCESS,
    };
}

function postDomainNoteRequest( domain ){
    return {
        domain,
        type: POST_DOMAIN_NOTE_REQUEST,
    };
}

function postDomainFailure( error ){
    return {
        error,
        type: POST_DOMAIN_NOTE_FAILURE,
    };
}

export const postDomainNote = ( domain, note ) => {
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( postDomainNoteRequest( domain ) );
        const api = new MimirService( DATA_API );

        return api.postDomainNotes( domain, note ).then(
            ( response ) => {
                dispatch( postDomainNoteSuccess( response ) );
            },
            ( error ) => dispatch( postDomainFailure( error ) )
        );
    };
};

export function fetchDomainNotes( domain ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchDomainNotesRequest( domain ) );
        const api = new MimirService( DATA_API );

        return api.getDomainNotes( domain ).then(
            ( response ) => dispatch( fetchDomainNotesSuccess( response ) ),
            ( error ) => dispatch( fetchDomainNotesFailure( error ) )
        );
    };
}
